<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="outer-wrap">
    <navigation-bar id="navBar" :title="title" :show-bottom-border="showBottom"
                    :background-color="backgroundColor" :text-color="textColor">
      <template v-slot:left>
        <slot name="left-btn"></slot>
      </template>
      <template v-slot:center>
        <slot name="center-content"></slot>
      </template>
      <template v-slot:right>
        <slot name="right-btn"></slot>
      </template>
    </navigation-bar>
    <!-- <div class="inner-wrap" :style="{ 'padding-top': innerWrapPaddingTop + 'rem',
         'background-color': contentBackgroundColor, 'padding-bottom': innerWrapPaddingBottom + 'rem'}"> -->
    <div class="inner-wrap" :style="{ 'padding-top': innerWrapPaddingTop + 'rem',
         'background-color': contentBackgroundColor}">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
import NavigationBar from './ActionBar'
import { mapGetters } from 'vuex'

export default {
  name: 'BasicLayout',
  props: {
    title: {
      type: String,
      default: ''
    },
    showBottomBorder: {
      type: Boolean,
      default: true
    },
    backgroundColor: {
      type: String,
      default: 'white'
    },
    textColor: {
      type: String,
      default: 'rgba(51, 51, 51, 1)'
    },
    contentBackgroundColor: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      showBottom: this.showBottomBorder
    }
  },
  components: {
    NavigationBar
  },
  computed: {
    ...mapGetters(['getStatusBarH', 'getNavigationBarH', 'getHomeKeyH']),
    innerWrapPaddingTop() {
      return (this.getStatusBarH + this.getNavigationBarH) / 75.0
    },
    innerWrapPaddingBottom() {
      return (this.getHomeKeyH / 75.0)
    }
  },
  methods: {},
  watch: {
    showBottomBorder: {
      immediate: true,
      handler: function (showBottomBorder) {
        this.showBottom = showBottomBorder
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.outer-wrap {
  .inner-wrap {
    font-family: SourceHanSansCN-Normal, serif;
    position: relative;
    height: 100vh;
  }
}
</style>
